import navigationService from "./navigation";
import { MemoryHistory } from "history";

export default class memoryHistory {
  push(path: any, state = {}, replace?: boolean) {
    navigationService._navigation(path, { state, replace });
  }

  back(): void {
    navigationService._navigation(-1);
  }
  get location(): Window["location"] {
    return window.location;
  }
}
